/* FS | PDP details - fit scale + model-size caption (ziggy PDP handoff).
   The theme's deferred-loading machinery can re-inject section DOM and strip
   element-bound listeners, so everything here is delegated at the document
   level and queries the DOM fresh on each event (same pattern as fs-mtf).
   Motion dispatches "variantChange" on the product section container
   (non-bubbling) - a capture-phase document listener still sees it. */
(function () {
  'use strict';
  if (window.__fsPdpDetailsInit) return;
  window.__fsPdpDetailsInit = true;

  function parseData(holder) {
    if (!holder) return null;
    if (holder.__fsParsed !== undefined) return holder.__fsParsed;
    try {
      holder.__fsParsed = JSON.parse(holder.textContent);
    } catch (err) {
      holder.__fsParsed = null;
    }
    return holder.__fsParsed;
  }

  function updateFitScales(scope, variant) {
    var roots = scope.querySelectorAll('[data-fs-fit-scale]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var data = parseData(root.querySelector('[data-fs-fit-data]'));
      if (!data) continue;
      var entry = data[String(variant.id)];
      if (!entry) {
        root.hidden = true;
        continue;
      }
      root.hidden = false;
      var marker = root.querySelector('[data-fs-fit-marker]');
      if (marker) marker.style.left = (entry.v / 6) * 100 + '%';
      var note = root.querySelector('[data-fs-fit-note]');
      if (note) {
        if (entry.n) {
          note.textContent = 'size ' + entry.s + ' · ' + entry.n;
          note.hidden = false;
        } else {
          note.hidden = true;
        }
      }
    }
  }

  function updateCaptions(scope, variant) {
    var roots = scope.querySelectorAll('[data-fs-model-caption]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var data = parseData(root.querySelector('[data-fs-caption-data]'));
      if (!data) continue;
      var text = (data.v && data.v[String(variant.id)]) || data.d || '';
      var textEl = root.querySelector('[data-fs-caption-text]');
      if (text) {
        if (textEl) textEl.textContent = text;
        root.hidden = false;
      } else {
        root.hidden = true;
      }
    }
  }

  document.addEventListener('variantChange', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    var scope = e.target && e.target.querySelectorAll ? e.target : document;
    updateFitScales(scope, variant);
    updateCaptions(scope, variant);
    updateTidyLabels(scope);
    updateLedger(scope, variant);
    settleDesktopCaption();
  }, true);

  /* --- Ledger revision (handoff 2) --------------------------------------- */

  function formatMoney(cents) {
    var format = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var wholeNum = Math.round(cents / 100);
    var noDecComma = wholeNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var commaAmount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1');
    var dl = '{' + '{', dr = '}' + '}';
    return format
      .replace(dl + 'amount_no_decimals_with_comma_separator' + dr, noDecComma)
      .replace(dl + 'amount_no_decimals_with_comma_seperator' + dr, noDecComma)
      .replace(dl + 'amount_with_comma_separator' + dr, commaAmount)
      .replace(dl + 'amount_with_apostrophe_separator' + dr, amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
      .replace(dl + 'amount_no_decimals' + dr, wholeNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(dl + 'amount' + dr, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  /* CTA price suffix and size guide row highlight - both driven by the same
     variantChange event. */
  function updateLedger(scope, variant) {
    var ctaPrice = scope.querySelector('[data-fs-cta-price]');
    if (ctaPrice && variant && typeof variant.price === 'number') {
      ctaPrice.textContent = '- ' + formatMoney(variant.price);
      ctaPrice.hidden = !variant.available;
    }
    updateSgRows();
    updateNotify(variant);
    reorderStrip();
  }

  /* --- inline back-in-stock notify (sold-out swatch handoff) ---------------- */

  var notifyVariantId = null;

  function selectedColorName() {
    var input = document.querySelector('.variant-input-wrap.clrfs input[data-variant-input]:checked');
    return input ? String(input.value).toLowerCase() : '';
  }

  /* sold-out shades sink to the end of the strip; available keep their
     original order. Disabled classes change with the selected size, so this
     re-sorts on every variantChange (cells are stamped with their original
     index at init). */
  function reorderStrip() {
    var row = document.querySelector('[data-fs-strip] .fs-strip__row');
    if (!row) return;
    var cells = [].slice.call(row.querySelectorAll('.variant-input'));
    if (!cells.length) return;
    for (var i = 0; i < cells.length; i++) {
      if (!cells[i].hasAttribute('data-fs-orig')) cells[i].setAttribute('data-fs-orig', String(i));
    }
    var sorted = cells.slice().sort(function (a, b) {
      var da = a.querySelector('input') && a.querySelector('input').classList.contains('disabled') ? 1 : 0;
      var db = b.querySelector('input') && b.querySelector('input').classList.contains('disabled') ? 1 : 0;
      if (da !== db) return da - db;
      return parseInt(a.getAttribute('data-fs-orig'), 10) - parseInt(b.getAttribute('data-fs-orig'), 10);
    });
    var changed = sorted.some(function (cell, i) { return cell !== cells[i]; });
    if (!changed) return;
    for (var j = 0; j < sorted.length; j++) row.appendChild(sorted[j]);
  }

  function updateNotify(variant) {
    var panel = document.querySelector('[data-fs-notify]');
    if (!panel) return;
    var meta = document.querySelector('.product-single__meta.pwt-tidy');
    var msg = panel.querySelector('[data-fs-notify-msg]');
    var input = panel.querySelector('[data-fs-notify-email]');
    var btn = panel.querySelector('[data-fs-notify-btn]');
    if (!variant || variant.available) {
      panel.hidden = true;
      if (meta) meta.classList.remove('fs-soldout');
      notifyVariantId = null;
      return;
    }
    if (meta) meta.classList.add('fs-soldout');
    var changed = notifyVariantId !== variant.id;
    notifyVariantId = variant.id;
    panel.hidden = false;
    if (changed) {
      panel.removeAttribute('data-mode');
      msg.textContent = selectedColorName() + " is sold out - get notified when it's back";
      input.hidden = true;
      btn.hidden = false;
      btn.disabled = false;
      btn.textContent = 'notify me';
    }
  }

  function notifySubscribe(panel, email) {
    var msg = panel.querySelector('[data-fs-notify-msg]');
    var input = panel.querySelector('[data-fs-notify-email]');
    var btn = panel.querySelector('[data-fs-notify-btn]');
    btn.disabled = true;
    btn.textContent = 'submitting...';
    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'a=VtiKvY&email=' + encodeURIComponent(email) +
        '&variant=' + notifyVariantId +
        '&product=' + (panel.getAttribute('data-product-id') || '') +
        '&platform=shopify'
    }).then(function (res) {
      if (!res.ok) throw new Error('subscribe failed');
      panel.removeAttribute('data-mode');
      msg.textContent = "✓ we'll email you when " + selectedColorName() + ' is back';
      input.hidden = true;
      btn.hidden = true;
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = "couldn't subscribe - try again";
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-fs-notify-btn]');
    if (!btn) return;
    var panel = btn.closest('[data-fs-notify]');
    if (!panel || !notifyVariantId) return;
    var input = panel.querySelector('[data-fs-notify-email]');
    var known = (panel.getAttribute('data-customer-email') || '').trim();
    if (known && known.indexOf('@') > -1) {
      notifySubscribe(panel, known);
      return;
    }
    if (input.hidden) {
      panel.setAttribute('data-mode', 'form');
      input.hidden = false;
      input.focus();
      return;
    }
    var email = String(input.value || '').trim();
    if (email.indexOf('@') < 1) {
      input.focus();
      return;
    }
    notifySubscribe(panel, email);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-fs-notify-email')) return;
    e.preventDefault();
    var panel = e.target.closest('[data-fs-notify]');
    var btn = panel && panel.querySelector('[data-fs-notify-btn]');
    if (btn) btn.click();
  });

  function selectedSizeValue() {
    var input = document.querySelector('.variant-input-wrap[data-handle="size"] input[data-variant-input]:checked');
    return input ? String(input.value).toLowerCase() : null;
  }

  function updateSgRows() {
    var size = selectedSizeValue();
    if (!size) return;
    var rows = document.querySelectorAll('[data-fs-sg-size]');
    for (var i = 0; i < rows.length; i++) {
      rows[i].classList.toggle('is-current', rows[i].getAttribute('data-fs-sg-size') === size);
    }
  }

  /* --- size guide drawer -------------------------------------------------- */

  function sgRoot() {
    return document.querySelector('[data-fs-sg]');
  }

  function openSg() {
    var root = sgRoot();
    if (!root) return;
    updateSgRows();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    var closeBtn = root.querySelector('.fs-sg__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeSg() {
    var root = sgRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var opener = e.target.closest('[data-fs-sg-open]');
    if (opener) {
      e.preventDefault();
      openSg();
      return;
    }
    var closer = e.target.closest('[data-fs-sg-close]');
    if (closer && closer.closest('[data-fs-sg]')) {
      /* compare handoff buttons carry data-csz-drawer-trigger too - let that
         handler run, just close this drawer alongside */
      if (!closer.hasAttribute('data-csz-drawer-trigger')) e.preventDefault();
      closeSg();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var root = sgRoot();
    if (root && root.classList.contains('is-open')) closeSg();
  });

  /* --- unified swatch strip ------------------------------------------------ */

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-fs-strip-more]');
    if (!btn) return;
    var strip = btn.closest('[data-fs-strip]');
    if (!strip) return;
    var expanded = strip.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });

  /* --- tidy gallery: one-time swipe nudge ---------------------------------- */

  function initGalleryNudge() {
    var carousel = document.querySelector('.product-photos-mobile-v2.fs-tidy-gallery .main-carousel');
    if (!carousel || carousel.children.length < 2) return;
    try {
      if (!window.matchMedia('(max-width: 589px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (sessionStorage.getItem('fsTidyGalleryNudged') === '1') return;
      carousel.classList.add('fs-tidy-nudge');
      sessionStorage.setItem('fsTidyGalleryNudged', '1');
      carousel.addEventListener('scroll', function () {
        carousel.classList.remove('fs-tidy-nudge');
      }, { once: true, passive: true });
    } catch (err) { /* private mode: skip the hint */ }
  }

  function updateRingsOverflow() {
    var track = document.querySelector('.pwt-tidy .ugc-stories__track');
    if (!track) return;
    track.classList.toggle('is-overflowing', track.scrollWidth > track.clientWidth + 4);
  }
  window.addEventListener('resize', updateRingsOverflow);

  function initLedger() {
    /* landing directly on a sold-out variant: the panel is server-rendered
       visible - seed the variant id from the product form so notify works
       before any variantChange fires */
    var notifyPanel = document.querySelector('[data-fs-notify]');
    if (notifyPanel && !notifyPanel.hidden) {
      var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (idInput && idInput.value) notifyVariantId = parseInt(idInput.value, 10) || null;
    }
    /* scrolling the swatch rail hides the "+ N colors" toggle so the rail
       can use the whole column; back at the start it returns */
    var stripScroll = document.querySelector('[data-fs-strip-scroll]');
    var stripEl = stripScroll ? stripScroll.closest('[data-fs-strip]') : null;
    if (stripScroll && stripEl) {
      stripScroll.addEventListener('scroll', function () {
        stripEl.classList.toggle('is-scrolled', stripScroll.scrollLeft > 4);
      }, { passive: true });
    }
    updateSgRows();
    initGalleryNudge();
    updateRingsOverflow();
    reorderStrip();
    window.addEventListener('load', updateRingsOverflow);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLedger);
  } else {
    initLedger();
  }

  /* --- Tidy buy box (ziggy cleanup) ------------------------------------- */

  /* "color - sugar" / "size - m" labels + the caption's color suffix follow
     the checked radios (already updated by the time variantChange fires). */
  function updateTidyLabels(scope) {
    var sizeInput = scope.querySelector('.variant-input-wrap[data-handle="size"] input[data-variant-input]:checked');
    var sizeLabel = scope.querySelector('[data-fs-tidy-size]');
    if (sizeLabel && sizeInput) sizeLabel.textContent = String(sizeInput.value).toLowerCase();

    var colorInput = scope.querySelector('.variant-input-wrap.clrfs input[data-variant-input]:checked');
    if (!colorInput) return;
    var colorName = String(colorInput.value).toLowerCase();
    var colorLabel = scope.querySelector('[data-fs-tidy-color]');
    if (colorLabel) {
      colorLabel.textContent = colorInput.classList.contains('disabled')
        ? colorName + ' · sold out'
        : colorName;
    }
    var captionColors = document.querySelectorAll('[data-fs-caption-color]');
    for (var ci = 0; ci < captionColors.length; ci++) captionColors[ci].textContent = colorName;
  }

  /* Calm delivery line: 2pm ET order cutoff, warehouse closed weekends plus
     Christmas Day and New Year's Day, next-business-day arrival.
     Order before 2pm ET -> arrives tomorrow (next open day). */
  function initTidyDelivery() {
    var holder = document.querySelector('[data-fs-tidy-delivery]');
    if (!holder || holder.__fsInit) return;
    holder.__fsInit = true;
    var target = holder.querySelector('[data-fs-arrives]');

    function etParts(date) {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false
      }).formatToParts(date);
      var out = {};
      for (var i = 0; i < parts.length; i++) out[parts[i].type] = parseInt(parts[i].value, 10);
      return out;
    }
    function isClosed(d) {
      if (d.getDay() === 0 || d.getDay() === 6) return true;
      var m = d.getMonth(), day = d.getDate();
      if (m === 11 && day === 25) return true;
      if (m === 0 && day === 1) return true;
      return false;
    }

    var now = etParts(new Date());
    /* local Date carrying the ET calendar date - only day arithmetic follows */
    var date = new Date(now.year, now.month - 1, now.day);
    if (now.hour >= 14) date.setDate(date.getDate() + 1);
    while (isClosed(date)) date.setDate(date.getDate() + 1);
    var remaining = 1;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      if (!isClosed(date)) remaining--;
    }
    var wd = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][date.getDay()];
    var mo = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'][date.getMonth()];
    if (target) target.textContent = wd + ', ' + mo + ' ' + date.getDate();
    holder.hidden = false;
    holder.style.visibility = 'visible';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTidyDelivery);
  } else {
    initTidyDelivery();
  }

  /* Desktop caption placement: the template-level caption instance moves
     inside the first VISIBLE desktop gallery cell so it reads directly under
     the lead image; re-run after colour switches (the gallery filter changes
     which cell is first). Mobile has its own instance inside the carousel
     wrapper, and the desktop grid is display:none below 1100px, so this move
     never affects mobile. */
  function placeDesktopCaption() {
    var cap = document.querySelector('[data-fs-caption-desktop]');
    var grid = document.querySelector('.product-photos-v2.fs-tidy-gallery .photo-container');
    if (!cap || !grid) return;
    var cells = grid.querySelectorAll('.carousel-cell');
    for (var i = 0; i < cells.length; i++) {
      // rendered-size check, not computed style: colour-filtered cells can
      // report display:block while collapsed to zero
      var r = cells[i].getBoundingClientRect();
      if (r.width > 10 && r.height > 10) {
        if (cap.parentNode !== cells[i]) cells[i].appendChild(cap);
        return;
      }
    }
  }
  /* the gallery's colour filter stamps/hides cells asynchronously after
     variantChange - a single post-event placement can land in a cell the
     filter is about to hide. Re-place on a short settle loop until the
     caption's host cell is genuinely rendered. */
  var capSettleTimer = null;
  function settleDesktopCaption() {
    var tries = 0;
    clearInterval(capSettleTimer);
    capSettleTimer = setInterval(function () {
      tries++;
      var cap = document.querySelector('[data-fs-caption-desktop]');
      var cell = cap && cap.closest('.carousel-cell');
      var ok = false;
      if (cell) {
        var r = cell.getBoundingClientRect();
        ok = r.width > 10 && r.height > 10;
      }
      if (!ok) placeDesktopCaption();
      if ((ok && tries > 1) || tries >= 12) clearInterval(capSettleTimer);
    }, 150);
    placeDesktopCaption();
  }
  /* NOTE: variantChange does not bubble (Motion dispatches it on the section
     container) - the re-place call lives in the file's capture-phase
     variantChange listener above. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', settleDesktopCaption);
  } else {
    settleDesktopCaption();
  }

  /* Hold the sticky header back while the buy box section is on screen: the
     fs-nav-hold class on <html> turns the theme's fixed .site-header--stuck
     into a static header (CSS in fs-buy-box-tidy-css) until the main product
     section has fully scrolled past. */
  function initNavHold() {
    var meta = document.querySelector('.product-single__meta.pwt-tidy');
    var header = document.getElementById('SiteHeader');
    if (!meta || !header) return;
    var mainSec = meta.closest('[id^="shopify-section"]');
    if (!mainSec) return;
    var held = null;
    var ticking = false;
    function update() {
      var hold = mainSec.getBoundingClientRect().bottom > 0;
      if (hold !== held) {
        held = hold;
        document.documentElement.classList.toggle('fs-nav-hold', hold);
      }
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavHold);
  } else {
    initNavHold();
  }

  /* Swatch rows scroll sideways; a right-edge gradient shows while more
     swatches sit off-screen and fades once scrolled to the end. */
  function updateSwatchOverflow() {
    var rows = document.querySelectorAll('.pwt-tidy .fs-tidy-swatch-row');
    for (var i = 0; i < rows.length; i++) {
      var dots = rows[i].querySelector('.fs-tidy-swatch-row__dots');
      if (!dots) continue;
      var overflowing = dots.scrollWidth > dots.clientWidth + 1;
      var atEnd = dots.scrollLeft + dots.clientWidth >= dots.scrollWidth - 2;
      rows[i].classList.toggle('is-overflowing', overflowing);
      rows[i].classList.toggle('is-at-end', atEnd);
    }
  }
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('fs-tidy-swatch-row__dots')) {
      updateSwatchOverflow();
    }
  }, true);
  window.addEventListener('resize', updateSwatchOverflow);
  window.addEventListener('load', updateSwatchOverflow);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSwatchOverflow);
  } else {
    updateSwatchOverflow();
  }

  /* "size guide" link: open + scroll the specs/fit accordion in place when the
     PDP has one (same pattern as testingABSizeGuide), else follow the href. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('[data-fs-size-guide]');
    if (!link) return;
    var trigger = document.getElementById('specs and fitO')
      || document.getElementById('specsO')
      || document.getElementById('perfect sizeO');
    if (!trigger) return;
    e.preventDefault();
    if (!trigger.classList.contains('is-open')) trigger.click();
    setTimeout(function () {
      trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);
  });
})();
